module.exports = __webpack_public_path__ + "static/img/slogan.54e9bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogan.png
// module id = iMv4
// module chunks = 1